module.exports = __webpack_public_path__ + "img/popup_confirm.56bb16ab.png";